<template>
	<Menu
		as="div"
		class="relative"
	>
		<MenuButton
			class="flex items-center focus:outline-hidden"
			@click="handleShow"
		>
			<div v-if="isNudgeVisible">
				<BellAlertIcon class="size-6 animate-bellShake text-won-green" />
				
				<span
					v-if="hasUnreadNotifications"
					class="absolute right-0 bottom-0 block size-1 rounded-full bg-won-red-dark"
				/>
			</div>
			<div
				v-else
				class="relative inline-block"
			>
				<BellIcon class="size-6 text-won-green" />
				<span
					v-if="hasUnreadNotifications"
					class="absolute right-0 bottom-0 block size-1 rounded-full bg-won-red-dark"
				/>
			</div>
		</MenuButton>

		<transition
			enter-active-class="transition ease-out duration-100"
			enter-from-class="transform opacity-0 scale-95"
			enter-to-class="transform opacity-100 scale-100"
			leave-active-class="transition ease-in duration-75"
			leave-from-class="transform opacity-100 scale-100"
			leave-to-class="transform opacity-0 scale-95"
		>
			<MenuItems
				class="
					absolute right-0 z-10 mt-2 origin-top-right rounded-lg bg-white
					shadow-notification-dropdown focus:outline-hidden
				"
				:class="menuWidthClass"
			>
				<div
					v-if="notifications.length > 0"
					class="p-4"
				>
					<ul
						role="list"
						class="list-none"
					>
						<li
							v-for="(event, eventIdx) in notifications"
							:key="event.id"
						>
							<div :class="[{ 'pb-4': eventIdx + 1 < notifications.length }]">
								<div :class="['flex items-start space-x-3', event.read_at ? '' : 'bg-won-green-hover']">
									<div class="shrink-0">
										<span
											v-if="event?.data.icon"
											class="[&_svg]:block [&_svg]:size-5"
											v-html="event?.data?.icon"
										/>

										<img
											v-else
											:src="wonLogoWhiteSrc"
											class="block size-5"
										/>
									</div>
									<ActivityMessage
										:message="event?.data?.message"
										:action-text="event?.data?.action_text"
										:action-link="event?.data?.link"
										:created-at="event?.created_at"
									/>
								</div>
							</div>
						</li>
					</ul>
				</div>

				<div
					v-else
					class="flex items-center justify-center p-2"
				>
					<BellSnoozeIcon class="mr-1 size-6 text-won-green" />

					<p class="text-center font-[Inter] text-sm font-medium text-won-blue">No new notifications</p>
				</div>
			</MenuItems>
		</transition>
	</Menu>
</template>

<script setup>
import { onMounted, computed } from 'vue';

import { storeToRefs } from 'pinia';

import { Menu, MenuButton, MenuItems } from '@headlessui/vue';
import { BellAlertIcon, BellIcon, BellSnoozeIcon } from '@heroicons/vue/24/outline';
import { useActivityStore } from '../../store/activity.store';

import ActivityMessage from './components/activity-message.vue';

const wonLogoWhiteSrc = '/img/logo-won-white.png';

const activityStore = useActivityStore();

const { isNudgeVisible, notifications, hasUnreadNotifications } = storeToRefs(activityStore);
const { fetchNotifications, markAllNotificationsAsRead } = activityStore;

const handleShow = async () => {
	await markAllNotificationsAsRead();
};

const menuWidthClass = computed(() => (notifications.value.length ? 'w-[560px]' : 'w-[217px]'));

onMounted(async () => {
	await fetchNotifications();
});
</script>